import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { setSelectedDeviceId } from '@/store/slices/device/deviceSlice';
import { useEffect, useCallback } from 'react';

export const useGlobalDeviceSelector = () => {
  const dispatch = useDispatch();
  const selectedDeviceId = useSelector((state: RootState) => state.device.selectedDeviceId);
  const isAuthenticated = useSelector((state: RootState) => state.auth.signedIn);

  // 如果用户未登录但有设备ID，重置设备选择
  useEffect(() => {
    if (!isAuthenticated && selectedDeviceId) {
      dispatch(setSelectedDeviceId(''));
    }
  }, [isAuthenticated, selectedDeviceId, dispatch]);

  const handleDeviceChange = useCallback((deviceId: string) => {
    dispatch(setSelectedDeviceId(deviceId));
  }, [dispatch]);

  return {
    selectedDeviceId,
    onDeviceChange: handleDeviceChange,
    isAuthenticated
  };
};

export default useGlobalDeviceSelector;